(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ch-deferred-app"] && !Shopify.designMode) return;
  try {
    const chDeferredAppObservers = new Map();

  function chDeferredAppObserver(rootMargin) {
    if (chDeferredAppObservers.has(rootMargin)) return chDeferredAppObservers.get(rootMargin);

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          entry.target.hydrate();
        });
      },
      { rootMargin }
    );

    chDeferredAppObservers.set(rootMargin, observer);
    return observer;
  }

  class CHDeferredApp extends HTMLElement {
    connectedCallback() {
      if (this.dataset.chDeferredAppHydrated === 'true') return;

      if (Shopify.designMode || !('IntersectionObserver' in window)) {
        this.hydrate();
        return;
      }

      chDeferredAppObserver(this.dataset.chDeferredRootMargin || '500px 0px').observe(this);
    }

    hydrate() {
      if (this.dataset.chDeferredAppHydrated === 'true') return;

      const template = this.querySelector('template');
      if (!(template instanceof HTMLTemplateElement)) return;

      this.dataset.chDeferredAppHydrated = 'true';
      this.querySelector('.ch-deferred-app__placeholder')?.remove();
      this.append(template.content.cloneNode(true));
      template.remove();
      this.initializeAliReviews();
      this.dispatchEvent(new CustomEvent('ch:deferred-app:loaded', { bubbles: true }));
    }

    initializeAliReviews(attempt = 0) {
      const initializers = [];

      if (this.querySelector('.alireviews-review-star-rating:not([data-status="initialized"])')) {
        initializers.push(window['__alr_app__alireviews-star-rating-block']?.default);
      }

      if (this.querySelector('.alireviews-reviews-carousel:not([data-status="initialized"])')) {
        initializers.push(window['__alr_app__alireviews-reviews-carousel-block']?.default);
      }

      const readyInitializers = initializers.filter((initializer) => typeof initializer === 'function');
      readyInitializers.forEach((initializer) => initializer());

      if (readyInitializers.length < initializers.length && attempt < 12) {
        window.setTimeout(() => this.initializeAliReviews(attempt + 1), 250);
      }
    }
  }

  if (!customElements.get('ch-deferred-app')) {
    customElements.define('ch-deferred-app', CHDeferredApp);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ch-delivery-estimate"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ch-delivery-estimate')) {
    customElements.define('ch-delivery-estimate', class extends HTMLElement {
      connectedCallback() {
        this.updateDates();
        this.refreshTimer = window.setInterval(() => this.updateDates(), 60000);
      }

      disconnectedCallback() {
        window.clearInterval(this.refreshTimer);
      }

      updateDates() {
        // Calendar days from the shopper's local today; no unconfirmed dispatch cutoff.
        const today = new Date();
        const start = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 4, 12);
        const end = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 9, 12);
        const options = { month: 'short', day: 'numeric' };
        if (start.getFullYear() !== today.getFullYear() || end.getFullYear() !== today.getFullYear()) {
          options.year = 'numeric';
        }
        const formatter = new Intl.DateTimeFormat(document.documentElement.lang || 'en-US', options);
        this.querySelector('[data-delivery-start]').textContent = formatter.format(start);
        this.querySelector('[data-delivery-end]').textContent = formatter.format(end);
        this.querySelector('[data-delivery-dates]').hidden = false;
        this.querySelector('[data-delivery-fallback]').hidden = true;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
